
import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../../helper/BaseUrl";





export default function ProductOthers({ className, initialData }) {
  const [allData, setAllData] = useState(initialData || []);
  const sectionRef = useRef(null);
  const mainSliderRef = useRef(null);
  const brandSliderRefs = useRef([]);

  useEffect(() => {
    let autoplayTimer;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!mainSliderRef.current) return;

        if (entry.isIntersecting) {
          // 🔹 reset to first slide
          mainSliderRef.current.slickPause();
          mainSliderRef.current.slickGoTo(0, true);

          // 🔹 start autoplay after 5 sec
          autoplayTimer = setTimeout(() => {
            mainSliderRef.current?.slickPlay();
          }, 5000);
        } else {
          mainSliderRef.current.slickPause();
          clearTimeout(autoplayTimer);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      observer.disconnect();
      clearTimeout(autoplayTimer);
    };
  }, []);



  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/product-categories`, {
        method: 'GET',
      });

      const result = await response.json();
      if (result.error === true) {
        throw new Error(`API error: ${result.message}`);
      } else {
        setAllData(result.product_categories);
      }
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    fetcher();
  }, [])

  /* ---------------- MAIN SLIDER SETTINGS ---------------- */
  const SliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: false, // ⛔ controlled manually
    pauseOnHover: true,
    autoplaySpeed: 4000,
    speed: 1200,
    cssEase: "ease",
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    prevArrow: (
      <button className="slick-arrow slick-prev" aria-label="Previous Slide">
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    ),
    nextArrow: (
      <button className="slick-arrow slick-next" aria-label="Next Slide">
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    ),
    responsive: [
      { breakpoint: 1050, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  /* ---------------- BRAND SLIDER SETTINGS ---------------- */
  const getBrandSliderSettings = (length) => ({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    slidesToShow: Math.min(3, length),
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false,
    swipe: false,
  });


  if (!allData.length > 3) { return null }

  return (
    <section className={`products-section ${className}`} ref={sectionRef}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="choose-text center-heading">
              <h2 className="heading">Explore Other Products</h2>
              <p>Discover additional high-performance equipment designed to enhance productivity, efficiency, and reliability across professional laundry and drycleaning operations.</p>
            </div>
          </div>
        </div>

        <div className="products-wrapper">
          <Slider {...SliderSettings} className="product-cards" ref={mainSliderRef}>
            {allData.map((products, i) => (
              <div className="product-card" key={i}>
                <div className="img-box">
                  <img src={products?.category_thumbnail ? `${BaseUrl}${products.category_thumbnail}` : undefined} className="img-responsive" alt={products?.alt_category_thumbnail} />
                </div>
                <div className="heading">{products?.name}</div>
                <p>{products?.brief}</p>
                <div className="brand-sliders">
                  <Slider {...getBrandSliderSettings(products.logos.length)} ref={(el) => (brandSliderRefs.current[i] = el)} className="brand-logo-slider" >
                    {products.logos.map((logo, index) => (
                      <div className="logos" key={index}>
                        <div className="brand-sliders-inner">
                          <img src={logo?.image ? `${BaseUrl}${logo.image}` : undefined} className="img-responsive" alt={logo?.alt_image} />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
                <Link to={`/product-listing/${products?.slug}`} className="default-btn">
                  <span>Explore {products?.name}</span>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}



